import "./tooltip.scss";

import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

function Tooltip(props) {
	let timeout;
	const [active, setActive] = useState(false);

	const wrapperRef = useRef(null);
	const tipRef = useRef(null);
	const [tipStyle, setTipStyle] = useState(null);

	const showTip = () => {
		timeout = setTimeout(() => {
			setActive(true);
		}, props.delay || 400);
	};

	const hideTip = () => {
		clearInterval(timeout);
		setActive(false);
	};

	useLayoutEffect(() => {
		if (!active || !props.useJsTargeting) return;

		const wrapperEl = wrapperRef.current;
		const tipEl = tipRef.current;

		if (!wrapperEl || !tipEl) return;

		const wrapperRect = wrapperEl.getBoundingClientRect();
		const tipRect = tipEl.getBoundingClientRect();

		const isBottomPlacement = props.jsPlacement === "bottom";
		const top = isBottomPlacement ? wrapperRect.bottom + 8 : wrapperRect.top - tipRect.height - 8;
		const left = wrapperRect.left + wrapperRect.width / 2 - tipRect.width / 2;

		setTipStyle({
			position: "fixed",
			top: Math.max(top, 56),
			left: Math.min(Math.max(left, 8), window.innerWidth - tipRect.width - 8),
			zIndex: 9999,
		});
	}, [active, props.jsPlacement, props.useJsTargeting]);

	const tooltipClassName = `Tooltip-Tip ${props.useJsTargeting ? "Tooltip-Tip--js" : ""} ${
		props.renderInPortal ? "Tooltip-Tip--portal competitive-intelligence-score-tooltip--portal bg-white" : ""
	}`;

	const tooltipContent =
		active &&
		(props?.tooltipFor === "amazon" ? (
			<div
				ref={props.useJsTargeting ? tipRef : null}
				className={tooltipClassName}
				style={props.useJsTargeting ? tipStyle : undefined}
			>
				{props?.subLabel ? <div className='tooltip-group-name'>{props.subLabel}</div> : null}
				<div className='tooltip-group-name'>{props.group && props.group}</div>
				<div className='tooltip-kwy-value-wrap'>
					<span>Number Of Employee :</span>
					<span>{props.employee && props.employee}</span>
				</div>
				<div className='tooltip-kwy-value-wrap'>
					<span>Mosaic Link :</span>
					<span>{props.url ? props.url : "*"}</span>
				</div>
			</div>
		) : props?.tooltipFor === "term" ? (
			<div
				ref={props.useJsTargeting ? tipRef : null}
				className={tooltipClassName}
				style={props.useJsTargeting ? tipStyle : undefined}
			>
				<div className='tooltip-group-name'>{props.description && props.description}</div>
			</div>
		) : (
			<div
				ref={props.useJsTargeting ? tipRef : null}
				className={tooltipClassName}
				style={props.useJsTargeting ? tipStyle : undefined}
			>
				<div className='tooltip-title'>{props.status && props.status}</div>
				<div className='tooltip-group-name'>{props.group && props.group}</div>
				<div className='tooltip-kwy-value-wrap'>
					<span>Employee Count :</span>
					<span>{props.employee && props.employee}</span>
				</div>
				<div className='tooltip-kwy-value-wrap'>
					<span>% of Total :</span>
					<span>{props.percentage && props.percentage.toFixed(2)}</span>
				</div>
				<div className='tooltip-kwy-value-wrap'>
					<span>Average Term :</span>
					<span>{props.avg_term && props.avg_term.toFixed(2)}</span>
				</div>
			</div>
		));

	return (
		<div
			ref={wrapperRef}
			className={`Tooltip-Wrapper ${props.class && props.class}`}
			onClick={() =>
				props.tooltipFor === "term"
					? ""
					: props.activeIndex === null
					? props.index2 !== undefined
						? props.setActiveIndex([props.index, props.index2])
						: props.setActiveIndex(props.index)
					: props.setActiveIndex(null)
			}
			style={props.style && props.style}
			onMouseEnter={showTip}
			onMouseLeave={hideTip}
		>
			{props.children}
			{tooltipContent && props.renderInPortal ? createPortal(tooltipContent, document.body) : tooltipContent}
		</div>
	);
}

export default Tooltip;
